<ng-container *ngIf="render$ | async" />

<div id="fastener-side-select-wrapper" cslPerfectScrollbar class="flex flex-col justify-center items-center flex-1">
  <csl-svg-workspace #svgWorkspace data-testid="svgWorkspace" [p]="panel" [sideSelectMode]="true" (selectSideChange)="selectSide($event)">
  </csl-svg-workspace>
</div>
